// should match TaskStatus enum from backend/src/utils/constants.py
export const TaskStatus = {
  IN_PROGRESS: "in progress",
  COMPLETED_PARTIAL: "completed partial",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled",
};

export const LogicNameFilter = {
  LOGIC_OR: "Or",
  LOGIC_AND: "And",
  TIME_AFTER: "After",
  TIME_BEFORE: "Before",
};

export const ComplexEntityTypes = {
  HOST: "host",
  USER: "user",
  SERVER: "server",
  DATA_STORE: "data_store",
  NONHUMAN_IDENTITY: "nonhuman_identity",
  APP: "app",
};

// should match OperationalHeatmapTypes enum from backend/src/utils/constants.py
export const OperationalHeatmapTypes = {
  ATTACK_PATH_BASED: "attack_path_based",
  CONTROLS_BASED: "controls_based",
};

export const entityTypes = () => {
  return [
    {
      id: 1,
      name: "Data Store",
      type: ComplexEntityTypes.DATA_STORE,
    },
    {
      id: 2,
      name: "Hosts",
      type: ComplexEntityTypes.HOST,
    },

    {
      id: 3,
      name: "Servers",
      type: ComplexEntityTypes.SERVER,
    },
    {
      id: 4,
      name: "Users",
      type: ComplexEntityTypes.USER,
    },
    {
      id: 5,
      name: "Non-human Identities",
      type: ComplexEntityTypes.NONHUMAN_IDENTITY,
    },
    {
      id: 6,
      name: "Apps",
      type: ComplexEntityTypes.APP,
    },
  ];
};

export const ProtectionLevelText = Object.freeze({
  // should match the enum from backend/src/utils/constants.py
  AT_RISK: "At Risk",
  MISSING_CONTROLS: "Missing Controls",
  DETECTION_ONLY: "Detection Only",
  PARTIAL_PROTECTION: "Partial Protection",
  OPTIMAL_PROTECTION: "Optimal Protection",
  RISK_ACCEPTED: "Risk Accepted",
});

export const ProtectionLevelOrder = {
  [ProtectionLevelText.AT_RISK]: 1,
  [ProtectionLevelText.MISSING_CONTROLS]: 2,
  [ProtectionLevelText.DETECTION_ONLY]: 3,
  [ProtectionLevelText.PARTIAL_PROTECTION]: 4,
  [ProtectionLevelText.OPTIMAL_PROTECTION]: 5,
  [ProtectionLevelText.RISK_ACCEPTED]: 6,
};

export const RemediationType = {
  REMEDIATION_PRIORITY: "remediationPriority",
  IMPACT: "impact",
  FEASIBILITY: "feasibility",
  STATUS: "status",
};

export const AD_ACCOUNT_OPTIONS_DISPLAY_NAMES = Object.freeze({
  DONT_EXPIRE_PASSWORD: "Password Never Expires",
  SERVER_TRUST_ACCOUNT: "Domain Controller",
  TRUSTED_FOR_DELEGATION: "Allowed To Delegate To Any Service (Kerberos Only)",
  TRUSTED_TO_AUTH_FOR_DELEGATION:
    "Allowed To Delegate To Specific Services (Any Authentication Protocol)",
  NOT_DELEGATED: "Account Is Sensitive And Cannot Be Delegated",
});

export const AssetTypes = [
  "External Application",
  "Internal Application",
  "Key People",
  "Sensitive Data",
  "Other",
];

export const StepsAssetWizard = {
  AssetDetailsStep: "Asset details",
  AutoSuggestionsStep: "Auto Suggestions",
  ManualAddStep: "Manual Add",
  ConfirmationStep: "Confirmation",
};

export const ManualSteps = [
  StepsAssetWizard.AssetDetailsStep,
  StepsAssetWizard.ManualAddStep,
];

export const AutoSuggestionsSteps = [
  StepsAssetWizard.AssetDetailsStep,
  StepsAssetWizard.AutoSuggestionsStep,
  StepsAssetWizard.ManualAddStep,
  StepsAssetWizard.ConfirmationStep,
];

export const ControlStatus = {
  GAP: "Gap",
  COMPLIANT: "Compliant",
  SNOOZED: "Snoozed",
  EXCLUDED: "Excluded",
};

// aligned with RemediationStatus in the backend
export const RemediationStatus = {
  PENDING: "Pending",
  RESOLVED: "Resolved",
  PARTIALLY_RESOLVED: "Partially Resolved",
};

// aligned with AutoRemediationLogStatus in the backend
export const AutoRemediationLogStatus = {
  AUTO_RESOLVED: "Auto Resolved",
  PARTIALLY_APPLIED: "Partially Applied",
  ROLLED_BACK: "Rolled back",
};

export const JiraStatus = {
  TODO: "To Do",
  IN_PROGRESS: "In Progress",
  DONE: "Done",
};

//NOTE: the same values are used in the backend in UserPlatformAccessRole enum
// User Platform access role
export const UserPlatformAccessRole = {
  MSSP: "MSSP",
  MSSP_VIEWER: "MSSP Viewer",
  SUPPORT: "Support",
  ADMIN: "Admin",
  USER: "User",
  VIEWER: "Viewer",
  LIMITED_VIEWER: "Limited Viewer",
};

export const MSSP_PLATFORM_ACCESS_ROLES = [
  UserPlatformAccessRole.MSSP,
  UserPlatformAccessRole.MSSP_VIEWER,
  UserPlatformAccessRole.SUPPORT,
];

export const VIEWER_ACCESS_DENIED_MESSAGE =
  'Your role, "Viewer", does not have permission to perform this action. Please contact your Admin for access.';

//NOTE: the same values are used in the backend in PlatformActions enum
export const PLATFORM_USER_ACTIONS = {
  SCAN_CONTROLS: "scan_controls",
  SNOOZE_AND_UNSNOOZE: "snooze_and_unsnooze",
  //For creating, editing, deleting, linking, and unlinking jira tickets
  MODIFY_TICKET: "modify_ticket",
  EXCLUDE_OR_INCLUDE_ENTITY_FROM_RISK: "exclude_or_include_entity_from_risk",
  REVOKE_GOOGLE_TOKENS: "revoke_google_tokens",
  RESTRICT_GOOGLE_FILE_ACCESS: "restrict_google_file_access",
  DISABLE_PASSWORD_REVEAL_IN_OKTA: "disable_password_reveal_in_okta",
  MODIFY_ASSET: "modify_asset",
  MODIFY_INTEGRATION: "modify_integration",
  UPDATE_REMEDIATION_COST: "update_remediation_cost",
  ACCEPT_ASSET_SUGGESTION: "accept_asset_suggestion",
  APPROVE_USER_PERMISSIONS: "approve_user_permissions",
  PING_ADMIN_PERMISSIONS: "ping_admin_permissions",
  UPDATE_OWNERSHIPS: "update_ownership",
  GENERATE_API_KEY: "generate_api_key",
  SUPPORT_ACTION: "support_action",
  VIEW_ALL_PAGES: "view_all_pages",
  ASSIGN_REMEDIATION_TO_USER: "assign_remediation_to_user",
  ASSIGN_CONTROL_TO_USER: "assign_control_to_user",
  UPDATE_REMEDIATION_CUSTOM_PRIORITY: "update_custom_remediation_priority",
  UPDATE_CONTROL_CUSTOM_SEVERITY: "update_control_custom_severity",
  REVOKE_ATLASSIAN_USER_ACCESS: "revoke_atlassian_user_access",
  NOTIFY_USER_ON_GOOGLE_DRIVE_FILES: "notify_user_on_google_drive_files",
  DELETE_ATLASSIAN_API_TOKEN: "delete_atlassian_api_token",
  REVOKE_ATLASSIAN_API_KEY: "revoke_atlassian_api_key",
};

export const UserPlatformTitle = [
  "Security Engineer",
  "IT",
  "CISO",
  "GRC",
  "Auditor",
];

//this should match the calculation in the backend for the CVEs breeze score
export const BREEZE_SCORE_WEIGHTS = {
  SCENARIOS: 0.4,
  COMPENSATING_CONTROLS: 0.3,
  OTHER_SOURCES: 0.3,
};

// This list is based on the steps BOK. It's duplicated with THREAT_SCENARIOS from platform secret.
// The list from the secret is read using the /threat-scenarios/ endpoint in backend/router.py, and used in Risk->Scenarios in the dropdown
// that has an impact on the execution step shown (executionSteps.js).
export const ThreatTypes = [
  "Phishing",
  "Ransomware",
  "Insider Threat",
  "Data Breach",
  "Supply Chain",
];

// Matches VulnerabilitySeverity in backend
export const VulnerabilitySeverity = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
};

export const JiraConfigureTicketAction = {
  CREATE: "create",
  EDIT: "edit",
  CONFIGURE: "configure",
};

export const AWSKmsKeyFieldsDescription = {
  CUSTOMER: "Customer Managed Key",
  AWS: "AWS Managed Key",
  SIGN_VERIFY: "Key can be used to sign and verify data",
  ENCRYPT_DECRYPT: "Key can be used to encrypt and decrypt data",
  GENERATE_VERIFY_MAC:
    "Key can be used to generate and verify MAC (Message Authentication Code)",
  AWS_KMS: "Key Material is generated by AWS KMS",
  EXTERNAL: "Key Material is imported by Customer",
  AWS_CLOUDHSM: "Key Material is generated by AWS CloudHSM",
  EXTERNAL_KEY_STORE: "Key is stored in External Key Store",
};

export const ENTITY_TABS = {
  PROPERTIES: "Properties",
  HISTORY: "History",
  POLICIES: "Policies",
  RISK: "Risk",
  VULNERABILITIES: "Vulnerabilities",
  TAGS: "Tags",
  PRIVILEGES: "Privileges",
  GROUPS: "Groups",
  PASSWORD_TRACKING: "Password Tracking",
  MFA: "MFA",
  CONNECTED_HOSTS: "Connected Hosts",
  ROLES: "Roles",
  REPOSITORY: "Repository",
  USERS: "Users",
  APPS: "Apps",
  CREDENTIALS: "Credentials",
  SECURITY_GROUPS: "Network Security Groups",
  ACTIVITY: "Activity",
  LOGINS: "Logins",
  COMPLIANCE: "Compliance",
  CLASSIFICATION: "Classification",
  OWNERSHIP: "Ownership",
  INSTALLED_PROGRAMS: "Installed Programs",
  RAW_DATA: "Raw Data",
};

export const DRAWER_TABS = {
  CONTROL_TAB: 0,
  DETECTION_TAB: 1,
  REMEDIATION_TAB: 2,
  ACTIVITY_TAB: 3,
};

export const STEPS_TABS = {
  STEPS_TAB: 0,
  DETECTION_TAB: 1,
};

export const PING_STATUS = {
  APPROVED: "Approved",
  PENDING: "Pending",
  PING_SENT: "Ping Sent",
};

export const JIRA_STATUS_CATEGORY = {
  TODO: "To Do",
  IN_PROGRESS: "In Progress",
  DONE: "Done",
};
export const JIRA_PRIORITY = {
  HIGHEST: "Highest",
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  LOWEST: "Lowest",
  TRIAGE: "Triage",
};
// Should match Platform enum in backend/constants.py
export const Platforms = {
  // Windows
  WINDOWS: "Windows",
  // macOS
  MACOS: "macOS",
  MAC: "Mac",
  // Linux
  LINUX: "Linux",
  DEBIAN: "Debian",
  DARWIN: "Darwin",
  AMAZON: "Amazon",
  AXIS: "Axis",
  // Linux - Redhat
  REDHAT: "Redhat",
  RHEL: "RHEL",

  // OTHER PLATFORMS
  MOBILE: "Mobile",
  TABLET: "Tablet",
  OTHER: "Other",
  ANY: "Any",

  NETWARE: "Netware",
  NA: "nan",
};

// Should match ServerOS enum in backend/src/utils/constants.py
// It's separated from Platforms to indicate to the user that the endpoint
// is running Server type OS.
export const ServerOS = {
  WINDOWS_SERVER: "Windows Server",
};

// Priority order for reliable OS version sources for servers
// Sources are checked in order from most to least reliable
export const RELIABLE_OS_VERSION_SOURCES = [
  "paloalto_cortex_xdr_data",
  "crowdstrike_data",
  "ninjaone_data",
];

export const COMPLEX_ENTITY_2ND_COLUMN_MAP = {
  user: { columnName: "Email", prop: "original_unique_id" },
  host: { columnName: "Last Seen", prop: "last_seen" },
  data_store: { columnName: "Type", prop: "resource_type" },
  server: { columnName: "ID", prop: "original_unique_id" },
  nonhuman_identity: { columnName: "ID", prop: "original_unique_id" },
  app: { columnName: "ID", prop: "original_unique_id" },
};

export const COMPLEX_ENTITY_3RD_COLUMN_MAP = {
  host: { columnName: "ID", prop: "original_unique_id" },
};

export const EntityTypeToDisplayName = {
  data_store: "Datastore",
  role: "Role",
  server: "Server",
  group: "Group",
  iamGroup: "IAM Group",
  policy: "Policy",
  user: "User",
  iamUser: "IAM User",
  gitHubUser: "GitHub User",
  rule: "Rule",
  app: "App",
  entra_id_app: "Entra ID App",
  host: "Host",
  okta_token: "Okta Token",
  google_token: "Google Token",
  nonhuman_identity: "Non-human identity",
  behavior: "Behavior",
  resource: "Resource",
  brand: "Brand",
  domain: "Domain",
  org: "Organization",
  aws_secret: "AWS Secret",
  website: "Website",
  account: "Account",
  scope: "Scope",
  asset: "Asset",
  organization: "Organization",
  repository: "Repository",
  admin_user: "Admin User",
  resource_set: "Resource Set",
  directory: "Directory",
  plan: "Plan",
  prestage_enrollment: "Prestage Enrollment",
  origin: "Origin",
  device: "Device",
  okta_app: "Okta App",
  jamf_user: "Jamf User",
  edr_app: "EDR App",
  greenhouse_candidate: "Greenhouse Candidate",
  atlassian_app: "Atlassian App",
  user_drive: "User Drive",
  shared_drive: "Shared Drive",
  device_volume: "Device Volume",
  eks_cluster: "EKS Cluster",
  ebs_snapshot: "EBS Snapshot",
  document: "Document",
  snowflake_user: "Snowflake Login",
  firewall: "Firewall",
  jumpcloud_user: "JumpCloud User",
  mcp_server: "MCP Server",
  board: "Board",
  device_profile: "Device Profile",
  dns_record: "DNS Record",
};

export const CONTROL_SEVERITY = {
  3: "High Severity",
  2: "Medium Severity",
  1: "Low Severity",
};

// the names are dictated by the BE model names in asset.py
export const AssetClass = {
  REGULAR: "RegularAsset",
  SMART: "SmartAsset",
};

export const AssetType = {
  REGULAR: "Custom Assets",
  SMART: "Smart Critical Assets",
  SUGGESTION: "Breeze’s Suggestions",
};

export const PageDisplayMode = {
  TABLE: "Table",
  GRID: "Grid",
  CARD: "Card",
};

export const HR_SYSTEM = ["hibob", "bamboohr"];

export const ASSET_CARD_SIZE = {
  WIDTH: 330,
  HEIGHT: 205,
  HEIGHT_CARD: 140,
  WIDTH_CARD: 420,
};

export const ASSET_CARD_SIZE_DIALOG = {
  WIDTH: 200,
  HEIGHT: 150,
};

export const AWSServiceType = Object.freeze({
  LAMBDA: "Lambda",
  ECS: "ECS",
  EKS: "EKS",
  EC2: "EC2",
  AMI: "AMI",
  WORKSPACE: "Workspace",
});

export const AzureServiceType = Object.freeze({
  VM: "Microsoft.Compute/virtualMachines",
});

// Matches DataStoreResourceType in backend
export const DataStoreResourceType = Object.freeze({
  DYNAMODB: "dynamodb",
  RDS: "rds",
  RDS_POSTGRES: "rds-postgres",
  RDS_MYSQL: "rds-mysql",
  RDS_AURORA: "rds-aurora",
  RDS_AURORA_MYSQL: "rds-aurora-mysql",
  RDS_AURORA_POSTGRESQL: "rds-aurora-postgresql",
  RDS_MARIADB: "rds-mariadb",
  RDS_ORACLE: "rds-oracle-ee",
  RDS_SQLSERVER: "rds-sqlserver-se",
  S3: "s3",
  SNOWFLAKE: "snowflake",
  MONGO_ATLAS: "mongoatlas",
  AZURE_BLOB_STORAGE: "azure_blob_storage",
  AZURE_SQL_DB: "Microsoft.Sql/servers/databases",
  AZURE_STORAGE_ACCOUNT: "Microsoft.Storage/storageAccounts",
  AZURE_BLOB_CONTAINER:
    "Microsoft.Storage/storageAccounts/blobServices/containers",
  AZURE_FILE_SHARE: "Microsoft.Storage/storageAccounts/fileServices/shares",
  AZURE_QUEUE: "Microsoft.Storage/storageAccounts/queueServices/queues",
  AZURE_TABLE: "Microsoft.Storage/storageAccounts/tableServices/tables",
  STARBURST_SNOWFLAKE_CATALOG: "starburst_snowflake_catalog",
  REPOSITORY: "Repository",
});

// Matches ComplexEntitySubtype in backend
export const NHIType = Object.freeze({
  AWS_SECRET: "aws_secret",
  AWS_KMS_KEY: "aws_kms_key",
  OKTA_TOKEN: "okta_token",
  AWS_IAM_USER: "iamUser",
  GITHUB_SECRET: "github_secret",
  GITHUB_ORG_TOKEN: "github_org_token",
  AZURE_KEYVAULT_SECRET: "Microsoft.KeyVault/vaults/secrets",
  AZURE_KEYVAULT_KEY: "Microsoft.KeyVault/vaults/keys",
  AZURE_KEYVAULT_CERTIFICATE: "Microsoft.KeyVault/vaults/certificates",
  AZURE_BLOB_CONTAINER:
    "Microsoft.Storage/storageAccounts/blobServices/containers",
  AZURE_FILE_SHARE: "Microsoft.Storage/storageAccounts/fileServices/shares",
  AZURE_QUEUE: "Microsoft.Storage/storageAccounts/queueServices/queues",
  AZURE_TABLE: "Microsoft.Storage/storageAccounts/tableServices/tables",
  SNOWFLAKE_SERVICE_USER: "snowflake_service_user",
  NOTION_BOT: "notion_bot",
  JAMF_API_KEY: "jamf_api_key",
  MICROSOFT_ENTRA_ID_APPLICATION: "microsoft_entra_id_application",
  ATLASSIAN_API_TOKEN: "atlassian_api_token",
  ATLASSIAN_API_KEY: "atlassian_api_key",
  ZENDESK_API_TOKEN: "zendesk_api_token",
  MICROSOFT_ENTRA_ID_SERVICE_PRINCIPAL: "microsoft_entra_id_service_principal",
  GITLAB_ACCESS_TOKEN: "gitlab_access_token",
  GITLAB_VARIABLE: "gitlab_variable",
  GITHUB_ORG_APP: "github_org_app",
  SALESFORCE_OAUTH_TOKEN: "salesforce_oauth_token",
  SLACK_SAAS_NHI: "slack_saas_nhi",
  OPENAI_ADMIN_API_KEY: "openai_admin_api_key",
  MICROSOFT_ACTIVE_DIRECTORY_SERVICE_USER:
    "microsoft_active_directory_service_user",
  CLAUDE_API_KEY: "claude_api_key",
  MONGO_ATLAS_API_KEY: "mongo_atlas_api_key",
});

// Matches EntityRisk in backend
export const EntityRisk = Object.freeze({
  MINIMAL: 1,
  LOW: 2,
  MEDIUM: 3,
  HIGH: 4,
  CRITICAL: 5,
});

// Matches TenantRisk in backend
export const TenantRisk = Object.freeze({
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  CRITICAL: "Critical",
});

// useQuery default cache time is 5 minutes. A greater stale time is irrelevant.
export const defaultStaleTime = 5 * 60 * 1000;

export const QueryParam = Object.freeze({
  environmentType: "environmentType",
  entity: "entity",
  id: "id",
  source: "source",
  notificationType: "notificationType",
  ctaType: "ctaType",
});
export const DetectionStatus = {
  NA: "N/A",
  OPEN: "Open",
  RESOLVED: "Resolved",
  IN_PROGRESS: "In Progress",
};

// Matches NotificationType in backend
export const NotificationType = {
  HIGH_RISK_GAP: "high_risk_gap",
  NEW_SCENARIO_SET: "new_scenario_set",
  HIGH_RISK_ENTITY: "high_risk_entity",
  DETECTION: "detection",
};

export const NotificationFilterTitle = {
  ALL: "All notifications",
  UNREAD: "Unread",
  SNOOZED: "Snoozed",
  SORT_BY_DATE: "Sort by Date",
  NOTIFICATION_TYPE: "Notification Type",
  INVOLVED_TOOLS: "Involved Tools",
};

export const ScenariosModalState = {
  UnifiedPaths: "Unified Paths",
  SinglePaths: "Single Paths",
};

export const ScenariosModalStateLogic = {
  UnifiedPaths: "UnifiedPaths",
  SinglePaths: "SinglePaths",
};
export const AttackerTooltip = {
  "External Application":
    "The attacker leverages compromised external applications to access additional data and credentials, leading to internal system access.",
  "Internal Application":
    "The attacker leverages compromised internal applications to pivot into systems, collect sensitive data, and obtain additional credentials.",
  "Sensitive Data":
    "The attacker, with access to sensitive data, is now leaking information while restricting access to the data and its backups, potentially for coercion or financial gain.",
  "Key People":
    "The attacker abuses credentials harvested from key people, leading to the compromise of sensitive business application data, which may be exploited for financial or strategic advantage.",
  Other:
    "Attacker with a foothold is collecting information about systems and identities, planning the execution of the next steps of the campaign",
};

export const DETECTION_SEVERITY = {
  1: "Low",
  2: "Medium",
  3: "High",
};

export const controlSeverity = {
  1: "Low",
  2: "Medium",
  3: "High",
};
// Complements TrackingEventType in backend
export const TrackingEventType = {
  TOOL_DEEP_LINK_CLICKED: "Tool Deep Link Clicked",
};

export const SLA_HIGH = 60;
export const SLA_CRITICAL = 30;

// Matches MSSP_TOKEN_DELIMITER in backend
export const MSSP_TOKEN_DELIMITER = ":";

export const CONTROLS_WITH_REVOKE_TOKEN_BUTTON = [
  78, 360, 361, 388, 397, 401, 436,
];

export const ATLASSIAN_CONTROL_WITH_REVOKE_API_KEY_BUTTON = [530];
export const ATLASSIAN_CONTROL_WITH_REVOKE_USER_ACCESS = [285, 424];
export const ENTITY_TYPE_WITH_REVOKE_TOKEN_BUTTON = ["google_token", "user"];
export const RESTRICT_GOOGLE_FILE_ACCESS_CONTROL = [398, 399, 400];
export const REMOVE_PERSONAL_EMAIL_PERMISSIONS_CONTROL = [555];
export const DISABLE_PASSWORD_REVEAL_IN_OKTA_CONTROL = [33, 338];
export const ATLASSIAN_CONTROL_WITH_DELETE_API_TOKEN_BUTTON = [529];
export const ATLASSIAN_CONTROL_WITH_DELETE_API_KEY_BUTTON = [530];

export const SHARED_GOOGLE_DRIVE_FILE_CONTROL_IDS = [398, 399, 400];
export const SHARED_PANORAYS_SUPPLIERS_CONTROL_IDS = [360, 436, 474, 476];
export const DOWNLOADED_GOOGLE_DRIVE_FILE_CONTROL_IDS = [406];
export const SHARED_BOX_FILE_CONTROL_IDS = [492, 493];
export const AZURE_LIST_BLOB_CONTAINER_CONTROL_IDS = [512];
export const AWS_S3_BUCKET_PUBLIC_READ_CONTROL_IDS = [90, 94, 289, 290];
export const MICROSOFT_ACTIVE_DIRECTORY_GROUP_MEMBER_COUNT_CONTROL_IDS = [
  583, 54,
];

export const CONTROLS_WITH_OTHER_MDM_COLUMN = [484, 465];

export const CONTROLS_WITH_CUSTOM_NOTIFICATIONS = [
  ...SHARED_GOOGLE_DRIVE_FILE_CONTROL_IDS,
  ...DOWNLOADED_GOOGLE_DRIVE_FILE_CONTROL_IDS,
];

export const PublicDataStorePermissions = {
  PUBLIC_READ: "publicRead",
  PUBLIC_WRITE: "publicWrite",
};

export const CustomWidgetPrivacy = {
  PUBLIC: "public",
  PRIVATE: "private",
};

export const GoogleFileHeader = {
  EVENT_DATE: "Event Date",
  TYPE: "Type",
  DOCUMENT_ID: "Document ID",
  OWNER: "Owner",
  LABELS: "Classification Labels",
  DOWNLOADING_USER: "Downloading User",
  SHARED_BY: "Shared By",
  SHARED_WITH: "Shared With",
  DRIVE_ID: "Drive ID",
};

export const NOT_DEPLOYED_LABEL = "Not Deployed";

export const ControlSeverityMssp = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  COMPLIANT: "Compliant",
  NOT_DEPLOYED: "Not Deployed",
};

export const LATEST = "Latest";

export const TimePoint = {
  LATEST: "Latest",
  THIRTY_DAYS: "30D",
  THREE_MONTHS: "3M",
  SIX_MONTHS: "6M",
  ONE_YEAR: "1Y",
};

export const RemediationPriority = {
  1: "Lowest",
  2: "Low",
  3: "Medium",
  4: "High",
  5: "Highest",
};

// one MUI spacing unit is 8px
export const MUI_SPACING = 8;

export const MISCONFIGURATION_ID_DELIMITER = "#";

// aligned with BREEZE_LOG_USER_ID in backend/posture/controls/activity_logs/constants.py
export const BREEZE_LOG_USER_ID = "breeze_activity";

// aligned with backend/posture/controls/activity_logs/constants.py
export const ActivityLogType = {
  // control logs
  NEW_GAP: "control_new_gap",
  NEW_COMPLIANT: "control_new_compliant",
  TURNED_GAP: "control_turned_gap",
  TURNED_COMPLIANT: "control_turned_compliant",
  ESCALATED: "control_escalated",
  IMPROVED: "control_improved",
  NOT_APPLICABLE: "control_not_applicable",
  APPLICABLE_GAP: "control_applicable_gap",
  APPLICABLE_COMPLIANT: "control_applicable_compliant",
  EXCLUDED_ENTITIES: "control_excluded_entities",
  INCLUDED_ENTITIES: "control_included_entities",
  CONTROL_EXCLUDED: "control_excluded",
  CONTROL_INCLUDED: "control_included",
  CONTROL_SNOOZED: "control_snoozed",
  CONTROL_UNSNOOZED: "control_unsnoozed",
  CONTROL_SNOOZE_ENDED: "control_snooze_ended",
  SNOOZED_ENTITIES: "control_snoozed_entities",
  UNSNOOZED_ENTITIES: "control_unsnoozed_entities",
  ENTITY_SNOOZE_ENDED: "control_misconfiguration_snooze_ended",
  SCAN: "control_scan",
  TICKET_CREATED: "control_ticket_created",
  TICKET_LINKED: "control_ticket_linked",
  TICKET_UNLINKED: "control_ticket_unlinked",
  TICKET_DELETED: "control_ticket_deleted",
  TICKETS_CREATED_FOR_ENTITIES: "control_tickets_created_for_entities",
  TICKET_CREATED_FOR_ENTITY: "control_ticket_created_for_entity",
  TICKET_LINKED_FOR_ENTITY: "control_ticket_linked_for_entity",
  TICKET_UNLINKED_FOR_ENTITY: "control_ticket_unlinked_for_entity",
  TICKET_DELETED_FOR_ENTITY: "control_ticket_deleted_for_entity",
  ASSIGNED: "control_assigned",
  UNASSIGNED: "control_unassigned",
  SEVERITY_RAISED: "control_severity_raised",
  SEVERITY_LOWERED: "control_severity_lowered",
  REMEDIATION_PRIORITY_RAISED: "control_remediation_priority_raised",
  REMEDIATION_PRIORITY_LOWERED: "control_remediation_priority_lowered",
  DETECTION_RESOLVED: "control_detection_resolved",
  AUTO_REMEDIATION: "control_auto_remediation",
  COMMENT: "control_comment",
  // remediation logs
  AUTO_RESOLVED: "remediation_auto_resolved",
  PARTIALLY_APPLIED: "remediation_partially_applied",
  ROLLED_BACK: "remediation_rolled_back",
};

export const PAGES = {
  CONTROLS: "controls",
};

export const MSSP_MULTI_TENANT_PAGES = ["environment", "vulnerabilities"];

export const CONTROLS_CATEGORY = [
  "DLP",
  "AI",
  "NHI",
  "EDR",
  "MFA",
  "Zero Trust",
  "Email",
];

export const LABEL_COLORS = {
  TAG_LABEL_1: "tag_label_1",
  TAG_LABEL_2: "tag_label_2",
  TAG_LABEL_3: "tag_label_3",
  TAG_LABEL_4: "tag_label_4",
  TAG_LABEL_5: "tag_label_5",
  TAG_LABEL_6: "tag_label_6",
  TAG_LABEL_7: "tag_label_7",
  TAG_LABEL_8: "tag_label_8",
  TAG_LABEL_9: "tag_label_9",
  TAG_LABEL_10: "tag_label_10",
};

export const ONBOARDING_STEPS = {
  WELCOME: "welcome",
  CONNECT_TOOLS: "connect_tools",
  SCAN: "scan",
  SCAN_PROGRESS: "scan_progress",
  SCAN_COMPLETE: "scan_complete",
  LEARN_BASICS: "learn_basics",
  COMPLETED: "completed",
};
